import { GetImages } from "../../../utils/GetImages";
import RequestBreadcrumb from "../../common/RequestBreadcrumb";
import { UtilityService } from "@propertelligent/client-api";
import apiHelper from "../../../utils/apiHelper";
import { useError } from "../../../utils/context/ErrorContext";
import { useEffect, useState } from "react";
import "./About.css";

// Permission support
import { PermissionGuard } from "../../../newComponents/PermissionGuard";
import NoAccess from "../../../pages/NoAccess";
import { AccessLevelEnum } from "@propertelligent/client-api";

const AboutComponent = () => {
  const { clearErrors } = useError();
  const [values, setValues] = useState({ appver: "" });

  useEffect(() => {
    getAppverData();
    clearErrors();
  }, []);

  const getAppverData = () => {
    apiHelper(UtilityService.getApiUtilityAppVer, { showNotification: false }, null)
      .then((res) => {
        
        setValues({ appver: res?.data?.success || "1.0.0" });
      })
      .catch(() => { });
  };

  return (
    <PermissionGuard permission="About" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
    <div className="about-wrapper">
     
      <h2 className="page-title">About Propertelligent</h2>

      {/* Description Card */}
      <div className="about-card-box">
        <p className="about-text">
          Propertelligent is a leading real estate intelligence platform, providing insights and data-driven solutions to help you make informed property decisions. Whether you're a buyer, seller, or investor, Propertelligent empowers you with up-to-date market data, analytics, and personalized recommendations.
        </p>
      </div>

      {/* Info Card */}
      <div className="about-card-box info-flex">
        {/* Contact Section */}
        <div className="info-item">
          <img src={GetImages.ContactIcon} className="info-icon color-white-icon" alt="Contact" />
          <div>
            <h4 className="info-heading">Contact Us</h4>
            <p className="info-detail">
              <span className="label">Email:</span> <span className="value link-text">support@propertelligent.com</span>
            </p>
            <p className="info-detail">
              <span className="label">Phone:</span> <span className="value">+1 (800) 123-4567</span>
            </p>
          </div>
        </div>

        {/* Version Section */}
        <div className="info-item">
          <img src={GetImages.PlatformIcon} className="info-icon color-white-icon" alt="Version" />
          <div>
            <h4 className="info-heading">Platform Version</h4>
            <p className="info-detail value">{values.appver}</p>
          </div>
        </div>
      </div>
    </div>
    </PermissionGuard>
  );
};

export default AboutComponent;